var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('TabResponsiveDropDown',{staticClass:"p-3 p-md-0",attrs:{"active-tab-index":_vm.indexOfCurrentTab,"tabsTheme":_vm.userStore.siteTabsTheme,"tabChoices":_vm.navItems}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }